export default "__VITE_ASSET__MpkMjdMB__"